import React, { useState, useEffect, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './RoleCarousel.css';

const roles = [
  'Расскажет о продукте на форуме',
  'Встретит гостя на рецепшен',
  'Запишет на услугу',
  'Выдаст талон электронной очереди',
  'Запишет контакт',
  'Выдаст гостевой пропуск',
  'Проведет экскурсию',
];

const RoleCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const longestRole = useMemo(
    () => roles.reduce((a, b) => (a.length >= b.length ? a : b)),
    []
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % roles.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="role-carousel">
      <div className="role-carousel-track">
        <span className="role-sizer" aria-hidden="true">
          {longestRole}
        </span>
        <AnimatePresence mode="wait">
          <motion.span
            key={currentIndex}
            className="role-item"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
          >
            {roles[currentIndex]}
          </motion.span>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default RoleCarousel;
